module.exports = __webpack_public_path__ + "img/avatar_1.af254904.png";